// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

const emptyPage = {
  title: "",
  description: "",
  id: "",
  slug: "",
  tags: /* [] */ 0,
  author: "",
  imgUrl: "",
  createdAtStr: "",
  createdAtLongStr: "",
  readingTime: 0
};

function tag(tags) {
  try {
    return Stdlib__List.hd(tags);
  }
  catch (exn){
    return "";
  }
}

function BlogPosts(Props) {
  let pages = Props.pages;
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  let firstPage;
  try {
    firstPage = Stdlib__List.hd(pages);
  }
  catch (exn){
    firstPage = emptyPage;
  }
  let otherPages;
  try {
    otherPages = Stdlib__List.tl(pages);
  }
  catch (exn$1){
    otherPages = /* [] */ 0;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      Caml_obj.caml_equal(firstPage, emptyPage) ? JsxRuntime.jsx("div", {
          className: "h-screen"
        }) : JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsx("p", {
              children: "#" + tag(firstPage.tags),
              className: "paragraph-small-medium text-primary"
            }),
            JsxRuntime.jsx(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* BlogPost */ 2,
                  _0: firstPage.slug
                }
              },
              className: "h4 text-black-landing mt-1 lg:mt-2",
              children: firstPage.title
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: firstPage.author,
                  className: "paragraph-small text-black-landing"
                }),
                JsxRuntime.jsxs("p", {
                  children: [
                    firstPage.createdAtLongStr,
                    " · ",
                    String(firstPage.readingTime),
                    Buhta_landing__I18n.trans(intl, "blog_min_read")
                  ],
                  className: "paragraph-small text-gray-landing ml-2"
                })
              ],
              className: "flex mt-1 lg:mt-2"
            }),
            JsxRuntime.jsx(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* BlogPost */ 2,
                  _0: firstPage.slug
                }
              },
              children: JsxRuntime.jsx("img", {
                className: "mt-4 h-43 lg:h-100 w-full lg:w-200 object-cover",
                alt: "buhta",
                src: firstPage.imgUrl
              })
            })
          ]
        }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.map((function (page) {
          const Key = page.id;
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: {
                    TAG: /* BlogPost */ 2,
                    _0: page.slug
                  }
                },
                children: JsxRuntime.jsx("img", {
                  className: "w-full lg:w-96 h-43 lg:h-50 object-cover",
                  alt: "buhta",
                  src: page.imgUrl
                })
              }),
              JsxRuntime.jsx("p", {
                children: "#" + tag(page.tags),
                className: "paragraph-small-medium text-primary mt-4"
              }),
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: {
                    TAG: /* BlogPost */ 2,
                    _0: page.slug
                  }
                },
                className: "h6 text-black-landing mt-1",
                children: page.title
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: page.author,
                    className: "paragraph-small text-black-landing"
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      page.createdAtLongStr,
                      " · ",
                      String(page.readingTime),
                      Buhta_landing__I18n.trans(intl, "blog_min_read")
                    ],
                    className: "paragraph-small text-gray-landing ml-2"
                  })
                ],
                className: "flex mt-1"
              })
            ],
            className: "w-full lg:w-96 mt-6 lg:mt-10"
          }, Key);
        }), otherPages)),
        className: "flex justify-between flex-wrap"
      })
    ],
    className: "lg:w-200"
  });
}

const make = BlogPosts;

export {
  emptyPage,
  tag,
  make,
}
/* Buhta_landing__Link Not a pure module */
